import type { DatesRangeValue } from '@mantine/dates';
import moment from 'moment-timezone';

export const getFinancialSummaryMonth = (
  timezone: string,
  referenceDate: Date = new Date()
): DatesRangeValue => {
  const local = moment.tz(referenceDate, timezone);
  return [
    new Date(local.year(), local.month(), 1),
    new Date(local.year(), local.month() + 1, 0)
  ];
};

export const buildFinancialSummaryDates = (range: DatesRangeValue) => {
  if (!range[0] || !range[1]) return null;
  const from = moment(range[0]).startOf('day');
  const to = moment(range[1]).startOf('day');
  if (!from.isValid() || !to.isValid() || to.isBefore(from) || to.diff(from, 'days') >= 366) {
    return null;
  }
  return { fromDate: from.format('YYYY-MM-DD'), toDate: to.format('YYYY-MM-DD') };
};

export const buildFinancialDrilldownLink = (
  pathname: string,
  storeId: string,
  period: { fromDate: string; toDate: string; timezone: string }
) => {
  const params = new URLSearchParams({
    storeId,
    fromDate: moment.tz(period.fromDate, 'YYYY-MM-DD', period.timezone).startOf('day').toISOString(),
    toDate: moment.tz(period.toDate, 'YYYY-MM-DD', period.timezone).add(1, 'day').startOf('day').toISOString(),
    timezone: period.timezone,
    exclusiveEnd: 'true'
  });
  return `${pathname}?${params}`;
};
